import Dexie from 'dexie';
import { ModelData } from './types';

export class ModelsDatabase extends Dexie {
  readonly models: Dexie.Table<ModelData, string>;

  constructor() {
    super('instructions-models');
    this.version(1).stores({ models: 'key' });
    this.models = this.table('models');
  }
}
